import { useMemo } from 'react';

import { Route, Routes, useLocation } from 'react-router-dom';

import { CheckoutModal } from '../pages/Checkout/Checkout';

const ShopOverlayRoutes = ({ basePath = '' }: { basePath?: string }) => {
  const location = useLocation();
  const state = location.state as { shopBackgroundLocation?: Location };

  const newLocation = useMemo(() => {
    if (!state?.shopBackgroundLocation) return null;
    return {
      ...state.shopBackgroundLocation,
      pathname: `${basePath}${state?.shopBackgroundLocation?.pathname}`,
    };
  }, [state, basePath]);

  return (
    <>
      {newLocation && (
        <Routes location={newLocation}>
          <Route path={`${basePath}/shop/carts/checkout`}>
            <Route path=":checkoutId" element={<CheckoutModal />} />
          </Route>
        </Routes>
      )}
    </>
  );
};

export { ShopOverlayRoutes };
